import * as alertMessagePortalFacadeImpl from './alertMessagePortalFacadeImpl';
import * as alertMessageWapFacadeImpl from './alertMessageWapFacadeImpl';
import * as alertMessageWebFacadeImpl from './alertMessageWebFacadeImpl';
import * as alertWebFacadeImpl from './alertWebFacadeImpl';
import * as announcementNoticeFacadeImpl from './announcementNoticeFacadeImpl';
import * as announcementNoticePortalFacadeImpl from './announcementNoticePortalFacadeImpl';
import * as baseEquipmentManageWapFacadeImpl from './baseEquipmentManageWapFacadeImpl';
import * as baseEquipmentManageWebFacadeImpl from './baseEquipmentManageWebFacadeImpl';
import * as baseInfoWapManageFacadeImpl from './baseInfoWapManageFacadeImpl';
import * as baseInfoWebManageFacadeImpl from './baseInfoWebManageFacadeImpl';
import * as checkPermissionPortalFacadeImpl from './checkPermissionPortalFacadeImpl';
import * as consumptionRatioFacadeImpl from './consumptionRatioFacadeImpl';
import * as diagramFacadeImpl from './diagramFacadeImpl';
import * as dingdingFacadeImpl from './dingdingFacadeImpl';
import * as environmentalMonitoringFacadeImpl from './environmentalMonitoringFacadeImpl';
import * as environmentalMonitoringWapFacadeImpl from './environmentalMonitoringWapFacadeImpl';
import * as epManageFacadeImpl from './epManageFacadeImpl';
import * as eventWapManageFacadeImpl from './eventWapManageFacadeImpl';
import * as eventWebManageFacadeImpl from './eventWebManageFacadeImpl';
import * as flowProcessManageFacadeImpl from './flowProcessManageFacadeImpl';
import * as iotLoginFacadeImpl from './iotLoginFacadeImpl';
import * as iotMonitorManageFacadeImpl from './iotMonitorManageFacadeImpl';
import * as iotMonitorWapManageFacadeImpl from './iotMonitorWapManageFacadeImpl';
import * as labourManageFacadeImpl from './labourManageFacadeImpl';
import * as labourManageWapFacadeImpl from './labourManageWapFacadeImpl';
import * as logOperateFacadeImpl from './logOperateFacadeImpl';
import * as loginFacadeImpl from './loginFacadeImpl';
import * as loginWapFacadeImpl from './loginWapFacadeImpl';
import * as materialInfoFacadeImpl from './materialInfoFacadeImpl';
import * as materialManageFacadeImpl from './materialManageFacadeImpl';
import * as notifyManageFacadeImpl from './notifyManageFacadeImpl';
import * as ossManageFacadeImpl from './ossManageFacadeImpl';
import * as paramManageFacadeImpl from './paramManageFacadeImpl';
import * as paramManageWapFacadeImpl from './paramManageWapFacadeImpl';
import * as personalTaskWapFacadeImpl from './personalTaskWapFacadeImpl';
import * as personalTaskWebFacadeImpl from './personalTaskWebFacadeImpl';
import * as planManageFacadeImpl from './planManageFacadeImpl';
import * as planMonthManageFacadeImpl from './planMonthManageFacadeImpl';
import * as planMonthManageWapFacadeImpl from './planMonthManageWapFacadeImpl';
import * as planQuarterManageFacadeImpl from './planQuarterManageFacadeImpl';
import * as planQuarterManageWapFacadeImpl from './planQuarterManageWapFacadeImpl';
import * as planSaleYearFacadeImpl from './planSaleYearFacadeImpl';
import * as planSaleYearIndicatorFacadeImpl from './planSaleYearIndicatorFacadeImpl';
import * as planSaleYearIndicatorWapFacadeImpl from './planSaleYearIndicatorWapFacadeImpl';
import * as planSaleYearWapFacadeImpl from './planSaleYearWapFacadeImpl';
import * as planWapManageFacadeImpl from './planWapManageFacadeImpl';
import * as planWeekManageFacadeImpl from './planWeekManageFacadeImpl';
import * as planWeekManageWapFacadeImpl from './planWeekManageWapFacadeImpl';
import * as planYearManageFacadeImpl from './planYearManageFacadeImpl';
import * as planYearManageWapFacadeImpl from './planYearManageWapFacadeImpl';
import * as productionRealTimeFacadeImpl from './productionRealTimeFacadeImpl';
import * as reportFacadeImpl from './reportFacadeImpl';
import * as roleManageFacadeImpl from './roleManageFacadeImpl';
import * as rolePermissionWapFacadeImpl from './rolePermissionWapFacadeImpl';
import * as rolePermissionWebFacadeImpl from './rolePermissionWebFacadeImpl';
import * as rstpFacadeImpl from './rstpFacadeImpl';
import * as runRecordFacadeImpl from './runRecordFacadeImpl';
import * as settingDetailWapFacadeImpl from './settingDetailWapFacadeImpl';
import * as settingDetailWebFacadeImpl from './settingDetailWebFacadeImpl';
import * as settingFacadeImpl from './settingFacadeImpl';
import * as settingMaterialFacadeImpl from './settingMaterialFacadeImpl';
import * as settingPlanFacadeImpl from './settingPlanFacadeImpl';
import * as syncOrgUserFacadeImpl from './syncOrgUserFacadeImpl';
import * as userLoginPermissionFacadeImpl from './userLoginPermissionFacadeImpl';
import * as userManageFacadeImpl from './userManageFacadeImpl';
import * as userWapManageFacadeImpl from './userWapManageFacadeImpl';
import * as visualFacadeImpl from './visualFacadeImpl';

export default {
  alertMessagePortalFacadeImpl,
  alertMessageWapFacadeImpl,
  alertMessageWebFacadeImpl,
  alertWebFacadeImpl,
  announcementNoticeFacadeImpl,
  announcementNoticePortalFacadeImpl,
  baseEquipmentManageWapFacadeImpl,
  baseEquipmentManageWebFacadeImpl,
  baseInfoWapManageFacadeImpl,
  baseInfoWebManageFacadeImpl,
  checkPermissionPortalFacadeImpl,
  consumptionRatioFacadeImpl,
  diagramFacadeImpl,
  dingdingFacadeImpl,
  environmentalMonitoringFacadeImpl,
  environmentalMonitoringWapFacadeImpl,
  epManageFacadeImpl,
  eventWapManageFacadeImpl,
  eventWebManageFacadeImpl,
  flowProcessManageFacadeImpl,
  iotLoginFacadeImpl,
  iotMonitorManageFacadeImpl,
  iotMonitorWapManageFacadeImpl,
  labourManageFacadeImpl,
  labourManageWapFacadeImpl,
  logOperateFacadeImpl,
  loginFacadeImpl,
  loginWapFacadeImpl,
  materialInfoFacadeImpl,
  materialManageFacadeImpl,
  notifyManageFacadeImpl,
  ossManageFacadeImpl,
  paramManageFacadeImpl,
  paramManageWapFacadeImpl,
  personalTaskWapFacadeImpl,
  personalTaskWebFacadeImpl,
  planManageFacadeImpl,
  planMonthManageFacadeImpl,
  planMonthManageWapFacadeImpl,
  planQuarterManageFacadeImpl,
  planQuarterManageWapFacadeImpl,
  planSaleYearFacadeImpl,
  planSaleYearIndicatorFacadeImpl,
  planSaleYearIndicatorWapFacadeImpl,
  planSaleYearWapFacadeImpl,
  planWapManageFacadeImpl,
  planWeekManageFacadeImpl,
  planWeekManageWapFacadeImpl,
  planYearManageFacadeImpl,
  planYearManageWapFacadeImpl,
  productionRealTimeFacadeImpl,
  reportFacadeImpl,
  roleManageFacadeImpl,
  rolePermissionWapFacadeImpl,
  rolePermissionWebFacadeImpl,
  rstpFacadeImpl,
  runRecordFacadeImpl,
  settingDetailWapFacadeImpl,
  settingDetailWebFacadeImpl,
  settingFacadeImpl,
  settingMaterialFacadeImpl,
  settingPlanFacadeImpl,
  syncOrgUserFacadeImpl,
  userLoginPermissionFacadeImpl,
  userManageFacadeImpl,
  userWapManageFacadeImpl,
  visualFacadeImpl,
};
